/**
 * A place to handle common file upload controls things
 */
namespace appn.fileUploadUtils {
    export function init() {
        $(document).on('input', '.fileinput input[type="file"]', function () {
            const file: File = (this as any).files[0];
            if (file === undefined)
                return;

            // Construct custom validation message
            const container = $(this).closest(".fileinput").parent();
            const validationContainer = container.find("[data-valmsg-for]");
            const maxSize: string = (appn._MAXFILESIZE / 1024 / 1024).toString();
            const userSize: string = (Math.round(file.size / 1024 / 1024)).toString();
            const error = `<span for="${(validationContainer.attr('data-valmsg-for')?.replace('.', '_'))}" generated="true" class="">${(appn.strings.fileSizeMax.replace('{0}', maxSize).replace('{1}', userSize))}</span>`;
            validationContainer.html('');
            validationContainer.append(error);

            if (utils.hasValue(file) && file.size > appn._MAXFILESIZE) {
                // Special case for setting error as this cannot be validated by the model
                validationContainer.removeClass('field-validation-valid');
                validationContainer.addClass('input-validation-error');

                $(this).val(''); // reset the field so that the file can't be uploaded
            }
            else {
                validationContainer.addClass('field-validation-valid');
                validationContainer.removeClass('input-validation-error');
            }
        });
    }

    export function enableFileUploadControl($fileInputParentDiv: JQuery<HTMLElement>) {
        $fileInputParentDiv.find('input').removeAttr('disabled');
        $fileInputParentDiv.find('.btn-file').removeAttr('disabled').removeClass('disabled');
        $fileInputParentDiv.find('.btn.iconReset').removeAttr('disabled');
        $fileInputParentDiv.find('.fileinput-new.thumbnail').css({ opacity: '1' });
    }

    export function disableFileUploadControl($fileInputParentDiv: JQuery<HTMLElement>) {
        $fileInputParentDiv.find('input').attr('disabled', appn.emptyString);
        $fileInputParentDiv.find('.btn-file').attr('disabled', appn.emptyString).removeClass('disabled').addClass('disabled');
        $fileInputParentDiv.find('.btn.iconReset').attr('disabled', appn.emptyString);
        $fileInputParentDiv.find('.fileinput-new.thumbnail').css({ opacity: '0.2' });
    }

    /**
     * Show a general file upload error dialog
     * @param errorMessage
     */
    export function fileUploadFailed(errorMessage?: string) {
        appn.dialog.alert({
            modalColor: 'modal-danger',
            title: T('File Upload Failed'),
            message: errorMessage ? errorMessage : T('An unexpected error occurred while uploading your file.'),
            buttons: {
                ok: {
                    label: '<span>' + T('OK') + '</span>',
                    className: 'btn-success'
                }
            },
            autoHeaderIcon: false
        });
    }
}
